module.exports = __webpack_public_path__ + "img/hp12.53f2d639.png";